import LegacyTag from '.';
import i18n from 'Services/i18n';

function ComplexTableLegacyTitle(props) {
    return (
        <div style={{ display: 'flex', gap: '12px' }}>
            <span>{i18n(props.title)}</span>
            <LegacyTag tooltipContent={props.tooltipContent} width="41px" fill="currentcolor" />
        </div>
    );
}

export default ComplexTableLegacyTitle;
